<template>
  <div>
    <my-header></my-header>
    <div class="main_body">
      <div class="content">
        <div class="content_title">练习结果</div>
        <el-divider></el-divider>
        <div class="content_name">练习名称：{{examObj.exerciseName }}</div>
        <div class="content_time">
          <span style="font-size: 14px">交卷时间：{{examObj.assignmentTime }}</span>
          <span style="font-size: 14px; margin-left: 20px">答题时长：{{examObj.totalTime }}</span>
        </div>
        <div class="content_state">{{examObj.totalPoints }}分</div>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import myHeader from "../../components/header.vue";
import myFooter from "../../components/footer.vue";
import { getCourseList, getExam } from "../../api/service.js";
export default {
  components: {
    myHeader,
    myFooter
  },
  data() {
    return {
      examObj: {},
      totalPoints: 0,
      totalScore: 0,
      totalNum: 0,
      isRightTotalNum: 0,
      isPass: 0,
      showScore: 0
    };
  },
  created() {
    this.examObj = JSON.parse(sessionStorage.getItem("examObj"));
    if (
      (this.$route.query.exerciseId != undefined &&
        this.$route.query.exerciseId != "") ||
      this.examObj === null
    ) {
      this.getExamDetail();
    } else {
      this.examObj.paperEntity.paperAreaList.forEach(obj => {
        obj.questionList.forEach(questionObj => {
          if (questionObj.isRight) {
            this.totalPoints = this.totalPoints + questionObj.score;
            this.isRightTotalNum = this.isRightTotalNum + 1;
          }
          this.totalNum = this.totalNum + 1;
          this.totalScore = this.totalScore + questionObj.score;
        });
      });
      this.examObj.totalPoints = this.totalPoints;
      this.examObj.totalScore = this.totalScore;
      this.examObj.totalNum = this.totalNum;
      this.examObj.isRightTotalNum = this.isRightTotalNum;
      this.getShowRule();
    }
  },
  methods: {
    //   获取当前试卷考试结果详情
    getExamDetail() {
      let url = "exercise/exerciseRecordResult";
      let data = {};
      data.exerciseRecordId = this.$route.query.recordId;
      getExam(url, data).then(res => {
        this.examObj = res.data;
        this.getShowRule();
      });
    },

    getShowRule() {
      if (
        this.examObj.totalPoints &&
        this.$route.query.passScore &&
        this.examObj.totalPoints > this.$route.query.passScore
      ) {
        this.isPass = 1;
      } else {
        this.isPass = 0;
      }
      if (this.$route.query.detailShow === 1) {
        this.showScore = 0;
      } else {
        if (this.examObj.totalPoints >= this.$route.query.passScore) {
          this.showScore = 1;
        } else {
          this.showScore = 2;
        }
      }
    }
  }
};
</script>

<style scoped>
.content_footer {
  width: 800px;
  height: 30px;
  font-size: 30px;
  margin: auto;
  margin-top: 40px;
  line-height: 30px;
  font-weight: 500;
  text-align: center;
}
.content_state {
  width: 150px;
  height: 150px;
  border: 1px solid black;
  border-radius: 50%;
  margin: auto;
  margin-top: 20px;
  text-align: center;
  color: red;
  line-height: 150px;
  font-size: 26px;
  font-weight: 500;
}
.content_time {
  width: 800px;
  margin: auto;
  text-align: center;
  height: 30px;
  margin-top: 20px;
}
.main_body {
  width: 1200px;
  height: 680px;
  margin: auto;
  overflow: hidden;
}
.content {
  width: 100%;
  height: 500px;
  margin-top: 100px;
  background-color: #fff;
  overflow: hidden;
}
.content_title {
  height: 30px;
  margin-top: 10px;
  font-size: 20px;
  text-indent: 20px;
  font-weight: 700;
  line-height: 30px;
}
.content_name {
  width: 800px;
  height: 30px;
  font-size: 30px;
  font-weight: 500;
  text-align: center;
  margin: auto;
  line-height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/pages/otherPracticeRerult/index.vue